//action always return an object
import { actionTypes } from "../constants/action-type";
//import fakestore api
import fakestoreapi from '../../apis/StoreApi';

export const fetchProducts = () => async (dispatch) => {
    const response = await fakestoreapi.get("/products",{
      headers: { 'Content-Type': 'application/json' }
    });
    dispatch({ type: actionTypes.FETCH_PRODUCTS, payload: response.data });  //function returning another function
  };

  export const fetchProduct = (id) => async (dispatch) => {
    const response = await fakestoreapi.get(`/products/${id}`,{
      headers: { 'Content-Type': 'application/json' }
    });
    dispatch({ type: actionTypes.SELECTED_PRODUCT, payload: response.data });  //function returning another function
  };

export const setProducts = (products) => {
  return {
    type: actionTypes.SET_PRODUCTS,
    payload: products,
  };
};

// //action 2
// export const selectedProduct = (product) => {
//   return {
//     type: actionTypes.SELECTED_PRODUCT,
//     payload: product,
//   };
// };

//action 3
export const removeSelectedProduct = () => {
  return {
    type: actionTypes.REMOVE_SELECTED_PRODUCT,
  };
};
